export default __webpack_public_path__ + "static/media/console.67890e24.jpg";